import React, { useEffect, useState } from "react";
import styles from "./LoadingProgressBar.module.css";
import { useSelector } from "react-redux";
import { getSearchResultsVisibleIndexes } from "../../../store/searchResults/selectors.js";
import { mcn } from "../../../utils/mergeClassnames.js";
const LoadingProgressBar = ({ variant }) => {
    const searchResultsVisibleIndexes = useSelector(getSearchResultsVisibleIndexes);
    const [progress, setProgress] = useState(0);
    useEffect(() => {
        if (!searchResultsVisibleIndexes) {
            setProgress(100);
            return;
        }
        const interval = setInterval(() => {
            setProgress((prev) => {
                const remaining = 95 - prev;
                const increment = remaining * 0.02;
                return prev + increment;
            });
        }, 100);
        return () => clearInterval(interval);
    }, [searchResultsVisibleIndexes]);
    return (React.createElement("div", { className: mcn(styles.container, variant === "mobile" ? styles.containerMobile : undefined) },
        React.createElement("div", { style: { transform: `scaleX(${progress / 100})` }, className: mcn(styles.loadingBar, variant === "mobile" ? styles.rounded : undefined) })));
};
export default LoadingProgressBar;
